var ngModule;
try {
  ngModule = angular.module('templates');
} catch (e) {
  ngModule = angular.module('templates', []);
}

ngModule.run(['$templateCache', function ($templateCache) {
  $templateCache.put('/modals/message-popup/message-popup.html',
    '<div class="modal-body" ng-click="messagePopup.close()">\n' +
    '    <button class="close"></button>\n' +
    '    <div ng-if="messagePopup.message">\n' +
    '        <p class="modal-info__text">{{ messagePopup.message }}</p>\n' +
    '    </div>\n' +
    '    <div ng-if="messagePopup.messages">\n' +
    '        <p class="modal-info__text">{{ messagePopup.title }}</p>\n' +
    '        <ul class="modal-info__text">\n' +
    '            <li style="list-style-type: disc;" ng-repeat="message in messagePopup.messages track by $index">{{ message }};</li>\n' +
    '        </ul>\n' +
    '    </div>\n' +
    '</div>');
}]);

module.exports = "/modals/message-popup/message-popup.html";